/**
 * Created by Olga Eremina on 19.10.2026
 */

const Merge2UndoTutorial = function () {
    return new TutorialScenario("merge2_undo_tutorial", {
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused(["unitInfoView"], true);
        },

        listSteps: () => {
            const unit = Merge2.current.field.findUnitToRemove();

            return [
                Merge2TutorialHelper.createClickUnitStep({
                    filter: (candidate) => Unit.Equals(candidate, unit),
                    finishEvent: "unitSelectionChanged",
                    highlightedCells: true,
                    force: cleverapps.clone(Forces.MERGE2_UNDO_HINT, true)
                }),
                Merge2UndoTutorial.createRemoveStep(),
                Merge2UndoTutorial.createConfirmStep(),
                Merge2UndoTutorial.createUndoStep()
            ];
        },

        isAvailable: function () {
            if (!Merge2.current || !Merge2.current.isGameMode() || Merge2.current.counter.isActive() || cleverapps.forces.isShown(Forces.MERGE2_UNDO_HINT)) {
                return false;
            }

            return cleverapps.user.checkAvailable(cleverapps.config.availables.UNDO_TUTORIAL)
                && Boolean(Merge2.current.field.findUnitToRemove());
        }
    });
};

Merge2UndoTutorial.getUnitInfoView = function () {
    return cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).unitInfoView;
};

Merge2UndoTutorial.createUnitInfoStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const createForce = () => {
                const unitInfoView = Merge2UndoTutorial.getUnitInfoView();
                const button = data.findButton(unitInfoView);

                if (!button) {
                    this.finish();
                    return;
                }

                const forceOptions = data.getForceOptions ? data.getForceOptions() : { highlights: [], importantNodes: [] };
                forceOptions.highlights.push(unitInfoView);
                forceOptions.importantNodes.push(unitInfoView);

                this.force = Merge2TutorialHelper.createForce(button, { text: data.text, ...data.force }, forceOptions);
            };
            createForce();

            cleverapps.tutorial.on("onResize", () => {
                if (this.isFinished()) {
                    return;
                }
                if (cleverapps.forces.isRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }
                createForce();
            }, this);

            cleverapps.tutorial.on(data.finishEvent, (options) => {
                if (!data.finishFilter || data.finishFilter(options)) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    });
};

Merge2UndoTutorial.createRemoveStep = function (force) {
    return Merge2UndoTutorial.createUnitInfoStep({
        text: "Merge2.UndoTutorial2",
        force,
        findButton: (unitInfoView) => ComponentUtils.findComponentByName(unitInfoView, "UnitInfoViewController").getRemoveButton(),
        getForceOptions: () => Merge2TutorialHelper.getHighlightCellsOptions([Merge2.current.field.selectedUnit]),
        finishEvent: "window_shown",
        finishFilter: (options) => options.windowName === "SellUnitWindow"
    });
};

Merge2UndoTutorial.createConfirmStep = function (force) {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window || window.name !== "SellUnitWindow") {
                this.finish();
                return;
            }

            this.force = Merge2TutorialHelper.createForce(window.sellButton, {
                text: "Merge2.UndoTutorial2",
                ...force
            }, {
                highlights: [window, cleverapps.Scenes.GetMovingNode(window)],
                importantNodes: [window]
            });

            cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    });
};

Merge2UndoTutorial.createUndoStep = function () {
    return Merge2UndoTutorial.createUnitInfoStep({
        text: "Merge2.UndoTutorial3",
        findButton: (unitInfoView) => {
            const undoButton = Merge2.current.field.removedUnit && ComponentUtils.findChildByName(unitInfoView, "undoButton");
            return undoButton && undoButton.isVisible() ? undoButton : undefined;
        },
        finishEvent: "unitSelectionChanged"
    });
};
